import $ from 'jquery';

if ($('.nav-item').length) {
  $('.nav-item').on('click', function (e) {
    if ($(e.target).closest('.offcanvas-dropdown').length) {
      return;
    }

    var $clickedItem = $(this);
    var $dropdown = $clickedItem.find('.offcanvas-dropdown');

    if ($clickedItem.hasClass('is-open')) {
      $clickedItem.removeClass('is-open');
      $dropdown.stop(true, true).slideUp();
    } else {
      $('.nav-item.is-open').each(function () {
        $(this).removeClass('is-open').find('.offcanvas-dropdown').stop(true, true).slideUp();
      });

      $clickedItem.addClass('is-open');
      $dropdown.stop(true, true).slideDown();
    }
  });
}
